/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFeatureSupportState: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvoc.GetFeatureSupportStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetFeatureSupportState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetManualOCLimits: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetManualOCLimitsParameters,
    Types.Nvapp.Nvoc.GetManualOCLimitsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetManualOCLimits',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLastOcScanResults: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetLastOcScanResultsParameters,
    Types.Nvapp.Nvoc.GetLastOcScanResultsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetLastOcScanResults',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLastIncompleteOcScannerResults: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetLastIncompleteOcScannerResultsParameters,
    Types.Nvapp.Nvoc.GetLastIncompleteOcScannerResultsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetLastIncompleteOcScannerResults',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFanSettings: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetFanSettingsParameters,
    Types.Nvapp.Nvoc.GetFanSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetFanSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OcScanStatusUpdatesNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvoc.OcScanStatusUpdatesNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'OcScanStatusUpdatesNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetOCConfig: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetOCConfigParameters,
    Types.Nvapp.Nvoc.GetOCConfigReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetOCConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvoc.GetGpuInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetGpuInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetOCAdminConsent: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvoc.GetOCAdminConsentReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetOCAdminConsent',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetOCAdminConsent: BridgeCommands.Command<
    Types.Nvapp.Nvoc.SetOCAdminConsentParameters,
    Types.Nvapp.Nvoc.SetOCAdminConsentReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'SetOCAdminConsent',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const powerStatusNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvoc.powerStatusNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'powerStatusNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetVFPoints: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetVFPointsParameters,
    Types.Nvapp.Nvoc.GetVFPointsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetVFPoints',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableCurrentVFPointNotification: BridgeCommands.Command<
    Types.Nvapp.Nvoc.EnableCurrentVFPointNotificationParameters,
    Types.Nvapp.Nvoc.EnableCurrentVFPointNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'EnableCurrentVFPointNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CurrentVFPointNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvoc.CurrentVFPointNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'CurrentVFPointNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPerfProfiles: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetPerfProfilesParameters,
    Types.Nvapp.Nvoc.GetPerfProfilesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetPerfProfiles',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetManualOCState: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetManualOCStateParameters,
    Types.Nvapp.Nvoc.GetManualOCStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetManualOCState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetManualOCProfile: BridgeCommands.Command<
    Types.Nvapp.Nvoc.GetManualOCProfileParameters,
    Types.Nvapp.Nvoc.GetManualOCProfileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvOc',
    method: 'GetManualOCProfile',
    persistent: false
};

export const Nvoc = {
GetFeatureSupportState,
GetManualOCLimits,
GetLastOcScanResults,
GetLastIncompleteOcScannerResults,
GetFanSettings,
OcScanStatusUpdatesNotifications,
GetOCConfig,
GetGpuInfo,
GetOCAdminConsent,
SetOCAdminConsent,
powerStatusNotification,
GetVFPoints,
EnableCurrentVFPointNotification,
CurrentVFPointNotification,
GetPerfProfiles,
GetManualOCState,
GetManualOCProfile
};
